import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PageLayout } from '../../common/PageLayout';
import Topbar from '../Topbar';
import { useParams } from 'react-router-dom';
import { IMeetingSimple } from '../../../../app/resource/meeting-simple/meeting-simple.types';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { CircularAvatar } from '../../common/CustomAvatar';
import { reportPageSelectors } from '../../../../app/page/page-storage/reports/reports.selectors';
import KpisMetrics from '../KpisMetrics';
import MeetingTeamDoughnutMetricCards from './MeetingTeamDoughnutMetricCards';
import QuarterlyInitiatives from '../QuarterlyInitiative';
import { fetchUsers } from '../../../../app/page/page-storage/users/users.actions';
import { fetchMeetingsSimple } from '../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { fetchMeetingReports } from '../../../../app/page/page-storage/reports/reports.actions';

const MeetingTeamReportsPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { meetingId } = useParams<{ meetingId: IMeetingSimple['id'] }>();

  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  useEffect(() => {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);

    dispatch(fetchUsers());
    dispatch(fetchMeetingsSimple());
    dispatch(fetchMeetingReports(meetingId, { dateSince: firstDayOfYear, dateUntil: today }));
  }, [dispatch, meetingId]);

  const report = useSelectWithParams(reportPageSelectors.selectMeetingReportByMeetingId, meetingId);

  return (
    <PageLayout smallSidebar>
      <div className="row mb-2">
        <div className="col-12">
          <div className="panel">
            <div className="panel-header small-header no-border pb-0 mb-1">
              <h2>
                Meeting Reports - <span className="bold">{meeting && meeting.title}</span>
              </h2>
            </div>
            <div className="cards-container-overflow meeting-report">
              <div className="cards-container">
                <div className="panel">
                  <div className="panel-body pt-0 ho-hover px-0">
                    <div className="border-radius-1 lightGray-bg p-2">
                      <div className="row">
                        <div className="col">
                          <Topbar meetingId={meetingId} />
                          {report && report.general && (
                            <>
                              <div className="panel my-1 p-2">
                                <div className="flex align-center" style={{ height: 120 }}>
                                  {meeting && (
                                    <>
                                      <CircularAvatar
                                        src={meeting.image}
                                        title={meeting.title}
                                        color={meeting.color}
                                        size="100"
                                        textSizeRatio={2}
                                        classes="img-fluid mr-05"
                                      />
                                      <div className="flex flex-column ml-2" style={{ flex: 1 }}>
                                        <div className="flex align-center justify-between border-bottom py-1">
                                          <div className="text-left bold">{`${meeting.title}`}</div>
                                        </div>
                                        <div className="flex align-center justify-between py-1">
                                          <div className="text-left"></div>
                                        </div>
                                      </div>
                                      <div className="flex align-center flex-column">
                                        <div className="avg-score">
                                          {report.general.attendance.avgScore > 0
                                            ? Math.round(report.general.attendance.avgScore * 10) / 10
                                            : '-'}
                                        </div>
                                        <span className="ml-1 mt-1">Average Meeting Score</span>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <MeetingTeamDoughnutMetricCards report={report.general} />
                              <QuarterlyInitiatives goalList={report.general.goals.list} showUsers />
                              <KpisMetrics kpis={report.general.kpis} showUsers />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MeetingTeamReportsPage;
